<template>

  <div>



    <t-form-list sortable hide-header
                 :generalErrors="generalErrors"
                 :items="items" :fields="fields" :command="command" :user-auth="userAuth" :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded" :path="pathTrigger"
                 :primary-key-column="primaryKeyColumn" :primary-key="form[primaryKeyColumn]"
                 :foreign-key-column="foreignKeyColumnTrigger" :foreign-key="foreignKey"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">


      <t-input v-model="form[primaryKeyColumn]" hidden />

      <b-col cols="12" class="mb-2">

        <b-row>

          <t-input cols="6" select-common v-model="form.typeTriggerActionId" :options="typeTriggerList"
                   :add-error="error.typeTriggerActionId" label="Tipo de Gatilho"
                   required/>


          <t-input cols="6" select-common v-model="form.triggerEventType"
                   :options="TriggerEventType.listByType(typeTrigger)"
                   label="Quando acionar"
                   required/>


        </b-row>


        <t-input v-if="form.typeTriggerActionId === TriggerAction.type.SEND_MAIL" required email-multiple v-model="form.paramString1"
                 label="E-mail(s) para envio"/>

        <t-input v-if="form.typeTriggerActionId === TriggerAction.type.GENERATE_LABEL_AND_SEND_PRINTER_DEFAULT" required select-common :options="labelList"
                 v-model="form.paramInteger1"
                 label="Layout de Etiqueta"/>

        <t-input v-if="form.typeTriggerActionId === TriggerAction.type.STOCK_PRODUCT_IN || form.typeTriggerActionId === TriggerAction.type.STOCK_PRODUCT_OUT" required select-common :options="stockProductLocationList"
                 v-model="form.paramInteger1"
                 label="Estoque de Produto"/>

        <t-input v-if="form.typeTriggerActionId === TriggerAction.type.GENERATE_REPORT_QUALITY" required select-common :options="technicalReportList"
                 v-model="form.paramInteger1"
                 label="Laudo de Qualidade"/>


        <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" primary submit/>

        <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
          {{ t('go-back') }}
        </b-link>


      </b-col>

      <template #list-content="{item,index}">

        <b-col cols="12">

          <span class="badge badge-pill badge-light bg-light">{{ ++index }}ª Prioridade</span><br/>

          <b-row class="mt-1">

            <b-col cols="12">
              <h5>{{ item.typeTrigger }}</h5>

              Quando: <b>{{ item.triggerEventTypeName }}</b>  qual: <b>{{ item.paramName }}</b><br/>

            </b-col>


          </b-row>

        </b-col>


      </template>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import TriggerAction from "@/model/types/resource/TriggerActionType";
import TriggerEventType from "@/model/types/resource/TriggerEventType";

import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 't-form-list-trigger',
  data() {
    return {
      TriggerAction,
      TriggerEventType,
      fields: [{keyRead: this.primaryKeyColumn, keyDelete: this.primaryKeyColumn}],
      form: {
        [this.foreignKeyColumnTrigger]: this.foreignKey,
        [this.primaryKeyColumn]: 0,
        typeTriggerActionId: 0,
        triggerEventType: 0,
        paramInteger1: 0,
        paramInteger2: 0,
        paramInteger3: 0,
        paramString1: "",
        paramString2: "",
        status: 1,
        //--------------------------------------------------------------------------
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        typeTriggerActionId: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      typeTriggerList: [],
      labelList: [],
      technicalReportList: [],
      stockProductLocationList: [],
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    typeTrigger: {//Criado o nome com sufixo do componente para não conflitar com campo type que possa ser utilizado
      type: String,
      required: true,
    },
    pathTrigger: {//Criado o nome com sufixo do componente para não conflitar com campo path já existente
      type: String,
      required: true,
    },
    foreignKeyColumnTrigger: {//Criado o nome com sufixo do componente para não conflitar com campo foreignKeyColumn já existente
      type: String,
      required: true,
    },
    primaryKeyColumn: {
      type: String,
      required: true,
    },
    foreignKey: {
      type: Number,
      required: true,
    },
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

    },

    mountedPrepare() {

      //Especifica campos vindo do componente externo
      this.path = this.pathTrigger
      this.foreignKeyColumn = this.foreignKeyColumnTrigger

      this.defaultForm()
      this.mountedPrepareFormListDefault()
      this.listParams.append("typeTrigger", this.typeTrigger)
    },

    async mountedContinued() {

      await http.list(this.pathTrigger + "/selectRelationList").then((response) => {

        this.typeTriggerList = response.typeTriggerList
        this.labelList = response.labelList
        this.technicalReportList = response.technicalReportList
        this.stockProductLocationList = response.stockProductLocationList

      }).catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.processFlowStepTriggerId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
